import FormikInputField from 'components/common/Fields/FormikInputField';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import { Field, Formik } from 'formik';
import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Container, FormGroup, Input, Label, Row } from 'reactstrap';
import useAxios from 'hooks/useAxios';
import { toast } from 'react-toastify';
import Tooltip from 'react-tooltip-lite'
import HoverImage from 'react-hover-image/build';
import Question from 'assets/icon/icons8-question-mark.svg'
import Loader from 'components/Loader';
import reseticon from "assets/icon/reset.svg";
import plus from "assets/icon/plus-icon.svg";
import save from "assets/icon/save.svg";
import cancel from "assets/icon/cancel.svg";


let hasDatePopupOpen = false;
let wholesalersData = [];
let accountTypeData = [];

const AddWholesalers = (props) => {
  const initialValues = {
    wholesaler: {},
    accountType: {},
    acctNum: {},
  };
  const { orgId, SelectedAccumulator, refetch,toggleAddWholesaler } = props
  const API = useAxios();

  console.log(SelectedAccumulator, 'AccumulatorId');

  const [selectedWhosaler, setSelectedWhosaler] = useState("");
  const [wholesaler, setWholeSalar] = useState([]);
  const [selectedWhosalererror, setSelectedWhosalerError] = useState("");
  const [loading, setLoading] = useState(false);
  const [accountType, setAccountType] = useState([]);

  const [selectedAccountType, setAccountTypeSelected] = useState("");
  const [hospitalName, setHospitalName] = useState('');
  const [acctNum, setAcctNum] = useState('');
const [accuntErr, setAccountErr] = useState(false);
  const [submit, setSubmit] = useState(false);

  useEffect(() => {
    fetchWholeSalers();
    fetchAccountType();
  }, []);
  const fetchWholeSalers = async () => {
    setLoading(true);
    try {
      const { data } = await API.get(
        `SBConfig/TypeStatus/WholesalerTypes`,
        {
          hasDefaultURL: true,
        }
      );
      console.log(data, "Ordering wholesalar");
      if (data) {
        setWholeSalar(data);
      }
      else {
        setWholeSalar([]);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);

    }
  };


  const handelSelectWholeSaler = (e, setFieldValue) => {
    const { value } = e.target;
    setFieldValue('wholesaler', value);
    setSelectedWhosaler(value);
  };


  const fetchAccountType = async () => {
    debugger;
    try {
      const { data } = await API.get(`SBConfig/TypeStatus/accountType`, { hasDefaultURL: true });
      console.log(data, "Account Type Data")
      if (data) {

        for (var x in data) {
          accountTypeData.push({ "id": data[x].id, "description": data[x].description });

        }
        setAccountType(data);
      }
      else {
        setAccountType([]);
      }

    }
    catch (err) {

    }
  }

  const handleAccountTypeChange = (e, setFieldValue) => {
    const { value } = e.target;
    setFieldValue('accounttype', value);
    setAccountTypeSelected(value);
    console.log(value, "handleAccountTypeChange")
  };

  const handleAcctNumberOnChange = (e, setFieldValue) => {
    const { value } = e.target;
    setFieldValue('acct', value);
    setAcctNum(value);
    console.log(value, "handleAcctNumberOnChange")
  };

  const handleHospitalChange = (e, setFieldValue) => {
    const { value } = e.target;
    setFieldValue('hospitalname', value);
    setHospitalName(value);

  };

  const handlePONUmberOnChange = (e, setFieldValue) => {
    const { value } = e.target;
    setFieldValue('poNumber', value);
    setPONumber(value);
    purchaseOrder.searchTerms.poNumber = value;
    updateStates(purchaseOrder);
  };
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };



  // const handleDateClick = (id) => {
  //   if (hasDatePopupOpen) {
  //     hasDatePopupOpen = false;
  //     return;
  //   }

  //   const calendarButton = document.getElementById(id);
  //   if (calendarButton) {
  //     calendarButton.click();
  //     hasDatePopupOpen = true;

  //   }
  // };
  const handleSubmit = async () => {
    debugger;
    setLoading(true);
    setSubmit(true);
    var list = {}
    let AddDrugWholesalerModel = [];
    list.AccumulatorID = SelectedAccumulator;
    list.WholesalerID = selectedWhosaler;
    list.HospitalName = hospitalName;
    list.AccountTypeID = selectedAccountType;
    list.AccountNumber = acctNum;
    AddDrugWholesalerModel.push(list)

    if (selectedWhosaler != "" && selectedWhosaler != undefined && selectedAccountType != "" && selectedAccountType != undefined && acctNum != "" &&
      acctNum != undefined && hospitalName != undefined && hospitalName != "" && SelectedAccumulator != "" && SelectedAccumulator != undefined) {
      setSubmit(false);

      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/DrugCatalog/SaveDrugWholesaler/${SelectedAccumulator}`,
        {AddDrugWholesalerModel},
        {
          hasDefaultURL: true,
        }
      );
      if (data.error == true) {
        // toast.error(data.message);
        setAccountErr(true);
       }
       else {
         toggleAddWholesaler();
         toast.success(data.message);
         refetch(SelectedAccumulator);
       }
       setLoading(false);

    }
    setLoading(false);
  }

  const handleReset = () => {
    setSelectedWhosaler("");
    setAccountTypeSelected("");
    setAcctNum("");
    setHospitalName("");
    toggleAddWholesaler();

  }

  return (
    <div>
      <div>
        <Card>
          <CardBody>
            {loading && (
              <div className="justify-content-center">
                <Loader />
              </div>
            )}
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
              children={(props) => {
                const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched, } = props;
                return (
                  <div hidden={""}>
                    <Row sm={12}>
                      <Col md={2} lg={3} sm={12} xs={12}>
                        {" "}
                        <FormGroup>
                          <Label for="Wholesaler">Wholesaler</Label>
                          <Field
                            className="required"
                            id="wholesaler"
                            name="wholesaler"
                            type="select"
                            placeholder="Select Location "
                            autoComplete="off"
                            options={wholesaler || []}
                            value={selectedWhosaler || ""}
                            component={FormikSelectField}
                            defaultoption="--Select--"
                            keys={{
                              id: "wholesalerId",
                              label: "wholesalerName",
                            }}
                            onChange={(e) =>
                              handelSelectWholeSaler(e, setFieldValue)
                            }
                          />
                          {submit &&
                          (selectedWhosaler === "" ||
                            selectedWhosaler === undefined) ? (
                            <div className="text-danger font-size-12">
                              Wholesaler is a required field
                            </div>
                          ) : (
                            ""
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={1} lg={1} sm={12} xs={12} style={{ marginTop: '38px', marginRight: '-50px', marginBottom: '5px' }}>
                        <Tooltip
                          content={
                            <div className="tip-list-info">
                              <p>
                                {/* <strong>Auto-Mapping : </strong> */}
                                <span>
                                  {" "}
                                  If wholesaler cannot be found in drop down
                                  open support ticket to request wholesaler to
                                  be added.
                                </span>
                              </p>
                            </div>
                          }
                          direction="right"
                          tagName="span"
                          className="target"
                          tipContentClassName=""
                          zIndex={99999}
                        >
                          <span className="cursor-pointer text-decoration-underline">
                            <HoverImage
                              src={Question}
                              hoverSrc={Question}
                              style={{ width: '20px', height: '20px' }}
                            ></HoverImage>
                          </span>
                        </Tooltip>
                      </Col>
                      <Col md={2} lg={2} sm={12} xs={12}>
                        {" "}
                        <FormGroup>
                          <Label for="accounttype">Account Type</Label>
                          <Field
                            className="required"
                            id="accounttype"
                            name="accounttype"
                            type="select"
                            placeholder="Select"
                            autoComplete="off"
                            options={accountType}
                            value={selectedAccountType}
                            component={FormikSelectField}
                            defaultoption="--Select--"
                            keys={{
                              id: "id",
                              label: "description",
                            }}
                            onChange={(e) =>
                              handleAccountTypeChange(e, setFieldValue)
                            }
                          />
                          {submit &&
                          (selectedAccountType === "" ||
                            selectedAccountType === undefined) ? (
                            <div className="text-danger font-size-12">
                              Account Type is a required field
                            </div>
                          ) : (
                            ""
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={12} xs={12}>
                        {" "}
                        <FormGroup>
                          <Label for="acct"> Acct #</Label>
                          <Input
                            id="acct"
                            className="required"
                            name="acct"
                            type="text"
                            placeholder="Enter Account Number"
                            autoComplete="off"
                            value={acctNum}
                            maxLength={15}
                            component={FormikInputField}
                            onChange={(e) => {
                              handleAcctNumberOnChange(e, setFieldValue);
                            }}
                          />
                          {submit &&
                          (acctNum === "" || acctNum === undefined) ? (
                            <div className="text-danger font-size-12">
                              Acct # is a required field
                            </div>
                          ) : (
                            ""
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={12} xs={12}>
                        {" "}
                        <FormGroup>
                          <Label for="hospitalname">Hospital Name</Label>
                          <div className="d-flex">
                            <Input
                              className="required"
                              id="hospitalname"
                              name="hospitalname"
                              type="text"
                              placeholder="Enter Hospital Name"
                              autoComplete="off"
                              value={hospitalName}
                              component={FormikInputField}
                              onChange={(e) => {
                                handleHospitalChange(e, setFieldValue);
                              }}
                            />
                          </div>
                          {submit &&
                          (hospitalName === "" ||
                            hospitalName === undefined) ? (
                            <div className="text-danger font-size-12">
                              Hospital Name is a required field
                            </div>
                          ) : (
                            ""
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row
                      style={{
                        justifyContent: "flex-end",
                        // marginRight: "10px",
                      }}
                    >
                      {accuntErr && <div className="text-danger font-size-12">
                        Wholesaler Configuration already exists
                      </div>}
                      <Col md="auto" className="d-flex justify-content-end">
                        <Label>{""}</Label>
                        <Button
                          color="primary"
                          className="search"
                          onClick={handleSubmit}
                        >
                          <span className="right_5">
                                                  <img src={save} alt="" />
                                                </span>{" "}
                          Save
                        </Button>

                        <Button
                          color="primary"
                          className="reset"
                          onClick={handleReset}
                        >
                          <span className="right_5">
                                                <img src={cancel} alt="" />
                                              </span>{" "}
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </div>
                );
              }}
            ></Formik>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default AddWholesalers